import { __makeTemplateObject } from "tslib";
import { css, getParsePaletteColor, typography, } from '../../../foundation';
import { MuiDefaultColor, RcCustomTypographyWeight } from '../utils';
export var TypographyStyle = function (_a) {
    var variant = _a.variant, color = _a.color, weight = _a.weight;
    var colorResult = !MuiDefaultColor.includes(color)
        ? getParsePaletteColor(color, null, false)
        : '';
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n    font-weight: ", ";\n    color: ", ";\n  "], ["\n    ", ";\n    font-weight: ", ";\n    color: ", ";\n  "])), typography(variant), weight && RcCustomTypographyWeight[weight], colorResult);
};
var templateObject_1;
